import { render, staticRenderFns } from "./flashpay-china-payment.vue?vue&type=template&id=ebb1117e&"
import script from "./flashpay-china-payment.vue?vue&type=script&lang=js&"
export * from "./flashpay-china-payment.vue?vue&type=script&lang=js&"
import style0 from "./flashpay-china-payment.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./flashpay-china-payment.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports